// Copyright (c) 2021 Deere & Company

// when modifying a field's value during an change event, react will move the cursor to the end.  This service captures the original position of the cursor and puts it back in the right place

export const fixCursorPosition = (event, formattedValue) => {

    const element = event.target;
    const caret = (element.value.length === formattedValue.length) ? element.selectionStart : element.selectionStart - (element.value.length - formattedValue.length);

    window.requestAnimationFrame(() => {

        element.selectionStart = caret;
        element.selectionEnd = caret;

    });

};



// WEBPACK FOOTER //
// ./src/shared/services/fix-cursor-position.js